// React
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
// Style
import "../../styles/menu/PaymentStyle.scss";
// Components
import Dial from "../../components/common/Dial";
// Recoil
import {
  useRecoilState,
  useRecoilValue,
  useResetRecoilState,
  useSetRecoilState,
} from "recoil";
import {
  cartState,
  customPayType,
  isOrderState,
  isRobot,
  orderState,
  paymentData,
} from "../../atom/menu";

function PaymentMembership() {
  // 멤버십 화면

  const navigate = useNavigate();
  // Recoil State
  const cartData = useRecoilValue(cartState);
  const isPrePay = useRecoilValue(customPayType);
  const [payment, setPayment] = useRecoilState(paymentData);
  const [orderData, setOrderData] = useRecoilState(orderState);
  const setRobotView = useSetRecoilState(isRobot);
  const resetCart = useResetRecoilState(cartState);
  const resetOrderState = useResetRecoilState(isOrderState);
  // useState
  const [step, setStep] = useState<number>(0); // 0 or 1
  const [pointNumber, setPointNumber] = useState<string>("");
  const [usePoint, setUsePoint] = useState<string>("0");
  const [completePopup, setCompletePopup] = useState<boolean>(false);
  const [disabled, setDisabled] = useState<boolean>(true);
  const [disabledPoint, setDisabledPoint] = useState<boolean>(true);

  const AVAILABLE_POINT = 4500;

  // Function
  const setOrderTotalAmount = () => {
    if (cartData && orderData) {
      const prevArray = [...orderData!.orderData];
      prevArray.unshift({
        orderData: cartData,
        payment: payment,
        orderTime: `${
          new Date().getHours() < 10
            ? "0" + new Date().getHours()
            : new Date().getHours()
        }:${
          new Date().getMinutes() < 10
            ? "0" + new Date().getMinutes()
            : new Date().getMinutes()
        }:${
          new Date().getSeconds() < 10
            ? "0" + new Date().getSeconds()
            : new Date().getSeconds()
        }`,
      });
      setOrderData({ ...orderData!, orderData: [...prevArray] });
    }
  };

  // Function
  useEffect(() => {
    // 휴대폰 번호 8자 이상 입력 안되게 처리
    if (pointNumber.length > 8) {
      setPointNumber(pointNumber.slice(0, 8));
    }
    if (pointNumber.length === 8) {
      setDisabled(false);
    } else {
      setDisabled(true);
    }
  }, [pointNumber]);

  useEffect(() => {
    // 조건
    // 1000원단위인지
    // 사용가능 포인트보다 작은지
    // 총 결제금액보다 작은지
    if (
      usePoint !== "0" &&
      Number.isInteger(Number(usePoint) / 1000) &&
      Number(usePoint) < AVAILABLE_POINT &&
      Number(usePoint) < calcTotalAmount()
    ) {
      setDisabledPoint(false);
    } else {
      setDisabledPoint(true);
    }
  }, [usePoint]);

  const nextAction = (type: string) => {
    if (type === "use") {
      // 포인트 사용하는 경우
      if (usePoint) {
        const prev = {
          ...payment,
          usePoint: Number(usePoint),
          totalAmount: calcTotalAmount(),
          payAmount: calcTotalAmount() - Number(usePoint),
        };
        setPayment(prev);
      }
    } else {
      const prev = {
        ...payment,
        usePoint: 0,
        totalAmount: calcTotalAmount(),
        payAmount: calcTotalAmount() - 0,
      };
      setPayment(prev);
    }
    if (isPrePay) {
      // isPrePay:true=선결제
      navigate("/menu/order/payment");
    } else {
      // isPrePay:false=후불
      setCompletePopup(true);
      const prev = {
        ...payment,
        payType: "pay-later",
      };
      setPayment(prev);
      setOrderTotalAmount();
    }
  };

  function calcTotalAmount() {
    // 총액 계산
    if (cartData) {
      let amt = 0 as number;
      let option = 0 as number;
      cartData.reduce((acc, cur) => {
        if (cur.option) {
          cur.option.reduce((acc2, cur2) => {
            option = acc2 + cur2.price * cur2.ea;
            return option;
          }, option);
          amt = acc + (cur.price + option) * cur.ea;
        } else {
          amt = acc + cur.price * cur.ea;
        }
        return amt;
      }, amt);
      let total = amt as number;
      return total;
    } else {
      return 0;
    }
  }

  const allPointUseEvent = () => {
    const useable = AVAILABLE_POINT - Number(String(AVAILABLE_POINT).slice(-3));
    setUsePoint(String(useable));
  };

  return (
    <>
      <div className='payment-cash-wrap'>
        <img
          className='absolute-logo'
          src={"/assets/images/menu/logo.png"}
          alt='vd company logo'
          style={{ width: 158 }}
        />
        <div className='flex row'>
          <div className='payment-membership-left'>
            {step === 0 ? (
              <>
                <div
                  className='TO-title-2 text-color-gray-3'
                  style={{ textAlign: "center", padding: "0 60px" }}
                >
                  고객님 휴대폰 번호 입력하고 포인트 적립하세요!
                </div>
                <div
                  className='flex col'
                  style={{
                    justifyContent: "center",
                    width: "auto",
                    gap: "18px",
                  }}
                >
                  <div
                    className='flex row'
                    style={{
                      height: "auto",
                      gap: "18px",
                      justifyContent: "flex-end",
                    }}
                  >
                    <div className='pink-box TO-title-5'>현금</div>
                    <div className='TO-title-3' style={{ color: "#919191" }}>
                      6% 적립
                    </div>
                  </div>
                  <div
                    className='flex row'
                    style={{
                      height: "auto",
                      gap: "18px",
                      justifyContent: "flex-end",
                    }}
                  >
                    <div className='pink-box TO-title-5'>신용카드</div>
                    <div className='TO-title-3' style={{ color: "#919191" }}>
                      4% 적립
                    </div>
                  </div>
                </div>
              </>
            ) : (
              <div className='point-wrap'>
                <div className='point-top'>
                  <div
                    className='TO-title-2 text-color-gray-3'
                    style={{ textAlign: "center", marginBottom: 20 }}
                  >
                    사용하실 포인트를
                    <br />
                    입력해 주세요
                  </div>
                  <div className='TO-body-1' style={{ color: "#929292" }}>
                    포인트는 1,000원부터 사용 가능합니다.{" "}
                  </div>
                </div>
                <div className='point-bottom'>
                  <div
                    className='pay-row'
                    style={{ maxWidth: "100%", marginBottom: 52 }}
                  >
                    <div
                      className='TO-title-2-small'
                      style={{ color: "#929292" }}
                    >
                      사용가능 포인트
                    </div>
                    <div className='TO-title-2-small text-color-gray-5'>
                      {AVAILABLE_POINT.toLocaleString()} P
                    </div>
                  </div>
                  <div className='pay-row' style={{ maxWidth: "100%" }}>
                    <div className='TO-body-3' style={{ color: "#929292" }}>
                      주문 금액
                    </div>
                    <div className='TO-body-3 text-color-gray-5'>
                      {calcTotalAmount()?.toLocaleString()} 원
                    </div>
                  </div>
                  <div className='pay-row' style={{ maxWidth: "100%" }}>
                    <div className='TO-body-3' style={{ color: "#929292" }}>
                      포인트 적립 금액
                    </div>
                    <div className='TO-body-3 text-color-gray-5'>
                      최종 결제 금액에서 결정
                    </div>
                  </div>
                  <div className='pay-row' style={{ maxWidth: "100%" }}>
                    <div className='TO-body-3' style={{ color: "#929292" }}>
                      포인트 사용 금액
                    </div>
                    <div className='TO-body-3 text-color-gray-5'>
                      {Number(usePoint).toLocaleString()} P
                    </div>
                  </div>
                  <div className='pay-row' style={{ maxWidth: "100%" }}>
                    <div className='TO-body-3' style={{ color: "#929292" }}>
                      총 결제 금액
                    </div>
                    <div className='TO-body-3 text-color-gray-5'>
                      {(calcTotalAmount() - Number(usePoint)).toLocaleString()}{" "}
                      원
                    </div>
                  </div>
                </div>
              </div>
            )}
            <div className='flex h-auto' style={{ marginTop: 24 }}>
              {step === 0 ? (
                <>
                  <div
                    className='basic-btn white TO-button-1 text-color-gray pointer'
                    onClick={() => {
                      navigate("/menu");
                    }}
                  >
                    이전으로
                  </div>
                  <div
                    className='basic-btn no-bg TO-button-1 pointer'
                    onClick={() => {
                      setStep(1);
                    }}
                  >
                    다음에하기
                  </div>
                </>
              ) : (
                <>
                  <div
                    className='basic-btn white TO-button-1 text-color-gray pointer'
                    onClick={() => {
                      setStep(0);
                    }}
                  >
                    이전으로
                  </div>
                  <div
                    className='basic-btn no-bg TO-button-1 pointer'
                    onClick={() => {
                      nextAction("");
                    }}
                  >
                    적립만하기
                  </div>
                </>
              )}
            </div>
          </div>
          <div className='payment-cash-right'>
            <div
              className='TO-title-3'
              style={{ marginTop: 8, color: "#929292" }}
            >
              {step !== 0 && "포인트는 1,000원 단위로 입력해 주세요."}
            </div>
            <div
              className='TO-title-1 relative w-100'
              style={{
                marginBottom: 72,
                height: 88,
                textAlign: "center",
              }}
            >
              {step === 0
                ? pointNumber.length > 4
                  ? "010-" +
                    pointNumber.slice(0, 4) +
                    "-" +
                    pointNumber.slice(4)
                  : "010-" + pointNumber.slice(0, 4)
                : Number(usePoint).toLocaleString()}
              {step === 1 && (
                <div
                  className='TO-button-2 use-all-point-btn'
                  onClick={() => {
                    allPointUseEvent();
                  }}
                >
                  전액입력
                </div>
              )}
            </div>
            <div className='number-pad-wrap'>
              {step === 0 ? (
                <Dial
                  type={"phone"}
                  value={pointNumber}
                  action={setPointNumber}
                />
              ) : (
                <Dial type={"point"} value={usePoint} action={setUsePoint} />
              )}
            </div>
            {step === 0 ? (
              disabled ? (
                <div
                  className='basic-btn TO-button-1 red-disabled'
                  style={{ marginTop: 16 }}
                  onClick={() => {
                    setStep(1);
                  }}
                >
                  확인
                </div>
              ) : (
                <div
                  className='basic-btn TO-button-1 pointer'
                  style={{ marginTop: 16 }}
                  onClick={() => {
                    setStep(1);
                  }}
                >
                  확인
                </div>
              )
            ) : disabledPoint ? (
              <div
                className='basic-btn TO-button-1 red-disabled'
                style={{ marginTop: 16 }}
              >
                포인트 사용
              </div>
            ) : (
              <div
                className='basic-btn TO-button-1 pointer'
                style={{ marginTop: 16 }}
                onClick={() => {
                  nextAction("use");
                }}
              >
                포인트 사용
              </div>
            )}
          </div>
        </div>
      </div>
      {completePopup && (
        <div
          className='menu-popup-bg'
          style={{ backgroundColor: "rgba(0, 0, 0, 0.75)" }}
        >
          <div
            className='TO-title-1'
            style={{ textAlign: "center", color: "#D8D8D8" }}
          >
            브이디메뉴로 주문 완료!
          </div>
          <div
            className='TO-title-2'
            style={{ textAlign: "center", color: "#D8D8D8" }}
          >
            매장에서 나가실 때 포스에서
            <br />
            결제를 꼭 완료해주세요
          </div>
          <img
            src={"/assets/images/menu/orderbot.gif"}
            alt='order complete bot'
            style={{ width: 748, position: "absolute", bottom: 127 }}
          />
          <div
            className='basic-btn TO-button-1 pointer'
            style={{
              maxWidth: 648,
              marginTop: 300,
              zIndex: 9,
            }}
            onClick={() => {
              resetCart();
              resetOrderState();
              setCompletePopup(false);
              setRobotView(true);
              navigate("/menu");
            }}
          >
            확인
          </div>
        </div>
      )}
    </>
  );
}
export default PaymentMembership;
